import React from 'react';
import { IAnswerGroup } from '../QuestionnairePrintView.service';

interface IEmailAddressTemplateProps {
  answerGroups: IAnswerGroup[];
}

const EmailAddressTemplate: React.FC<IEmailAddressTemplateProps> = ({ answerGroups }) => {
  return (
    <>
      {answerGroups.map((group, index) => (
        <div key={index} className="flex items-center">
          <p>{group.answerMapping['0']?.answerForQuestion}</p>
          {group.answerMapping['1']?.answerForQuestion === 'yes' && <i className="ml-1">(Primary)</i>}
        </div>
      ))}
    </>
  );
};

export default EmailAddressTemplate;
